import cogoToast from "cogo-toast";
import { createSlice } from "@reduxjs/toolkit";
import { t } from "i18next";

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState: {
    wishlistItems: [],
  },
  reducers: {
    addToWishlist(state, action) {
      const isInWishlist = state.wishlistItems.findIndex(
        (item) => item.id === action.payload.id
      );
      if (isInWishlist > -1) {
        cogoToast.info(t("item_removed_from_wishlist"), {
          position: "bottom-center",
          heading: t("wishlist"),
        });
      } else {
        state.wishlistItems.push(action.payload);
        cogoToast.success(t("item_added_to_wishlist"), {
          position: "bottom-center",
          heading: t("wishlist"),
        });
      }
    },
    deleteFromWishlist(state, action) {
      state.wishlistItems = state.wishlistItems.filter(
        (item) => item.id !== action.payload
      );
      cogoToast.error(t("item_removed_from_wishlist"), {
        heading: t("wishlist"),
        position: "bottom-center",
      });
    },
    deleteAllFromWishlist(state) {
      state.wishlistItems = [];
    },
  },
});

export const { addToWishlist, deleteFromWishlist, deleteAllFromWishlist } =
  wishlistSlice.actions;
export default wishlistSlice.reducer;
